/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useParams } from "react-router";
import {APP_DOMAINURL} from '../../services/config'
import { Container } from "@material-ui/core";

const Employee = (props) => {
  const {employeeId}= useParams();
  
  return (
    <>
      <Container>
        <div className={`sectionBox dark:bg-[#1A1F2C]`} style={{height:'90vh', justifyContent:'center', display:'flex'}}>
        <iframe src={`${APP_DOMAINURL}${employeeId}`} title="Mobile App" frameBorder="2" style={{borderRadius:10}} width="375" height="100%"></iframe>

        </div>
      </Container>
    </>
  );
};
export default Employee;
